import { render, staticRenderFns } from "./GenerativeAI.vue?vue&type=template&id=2ede083b&scoped=true&"
import script from "./GenerativeAI.vue?vue&type=script&lang=js&"
export * from "./GenerativeAI.vue?vue&type=script&lang=js&"
import style0 from "./GenerativeAI.vue?vue&type=style&index=0&id=2ede083b&prod&scoped=true&lang=css&"
import style1 from "./GenerativeAI.vue?vue&type=style&index=1&id=2ede083b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ede083b",
  null
  
)

export default component.exports